export default "__VITE_ASSET__5YS3JrDL__"